import { ListingPricingValues } from '@ha/api/v2/types/Listing';

export function getMinPriceFromAdvancedPricing(
  listingMonthlyPrice: number,
  pricingValues?: ListingPricingValues,
): number {
  if (!pricingValues?.monthly) {
    return (pricingValues?.flat || listingMonthlyPrice) / 100;
  }

  return Math.min(...Object.values(pricingValues.monthly)) / 100;
}
